import { useCallback, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { createApiClient } from '../lib/api-client';

const PROVIDERS = [
  { id: 'openai', name: 'OpenAI', models: ['gpt-4', 'gpt-4-turbo', 'gpt-3.5-turbo'] },
  { id: 'anthropic', name: 'Anthropic', models: ['claude-3-opus', 'claude-3-sonnet', 'claude-3-haiku'] },
  { id: 'google', name: 'Google AI', models: ['gemini-pro', 'gemini-ultra'] },
  { id: 'aws_bedrock', name: 'AWS Bedrock', models: ['anthropic.claude-3-sonnet', 'amazon.titan'] },
  { id: 'openrouter', name: 'OpenRouter', models: ['openrouter/gpt-4', 'openrouter/gpt-4-turbo', 'openrouter/claude-3', 'openrouter/gpt-3.5-turbo'] },
  { id: 'minimax', name: 'MiniMax', models: ['mini-max-01'] },
];

export function useProviderKeys() {
  const { getAccessToken } = useAuth();
  const api = useMemo(() => createApiClient(getAccessToken), [getAccessToken]);

  const getProviderKeys = useCallback(async () => {
    const data = await api.get('/settings/provider-keys');
    return data.keys || [];
  }, [api]);

  const addProviderKey = useCallback(async (providerId, apiKey) => {
    const data = await api.post('/settings/provider-keys', { providerId, apiKey });
    return data;
  }, [api]);

  const activateProviderKey = useCallback(async (providerId) => {
    const data = await api.put('/settings/provider-keys', { providerId, action: 'activate' });
    return data;
  }, [api]);

  const deactivateProviderKey = useCallback(async (providerId) => {
    const data = await api.put('/settings/provider-keys', { providerId, action: 'deactivate' });
    return data;
  }, [api]);

  const deleteProviderKey = useCallback(async (providerId) => {
    await api.del(`/settings/provider-keys/${providerId}`);
    return true;
  }, [api]);

  return {
    getProviderKeys,
    addProviderKey,
    activateProviderKey,
    deactivateProviderKey,
    deleteProviderKey,
    providers: PROVIDERS,
  };
}

export { PROVIDERS };